<ng-template let-last="last" let-nextBtnLbl="nextBtnLbl" let-doneBtnLbl="doneBtnLbl">
  <div class="step-container">
    <div class="step-content">
      <ng-content></ng-content>
    </div>
    <div class="step-buttons">
      @if (last) {
        <div>
          <mad-primary-button data-cy="complete-step-button" (click)="completeLast()">{{ doneBtnLbl }}</mad-primary-button>
        </div>
      } @else {
        <div>
          <mad-primary-button data-cy="next-step-button" (click)="next()">{{ nextBtnLbl }}</mad-primary-button>
        </div>
      }
    </div>
  </div>
</ng-template>
